module.exports = __webpack_public_path__ + "static/media/LL83d80f4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/LL.svg
// module id = 1303
// module chunks = 0